<template>
  <v-container>
    <v-row class="mt-12">
      <v-col class="mt-12">
        <div
          :class="{
            'display-4': $vuetify.breakpoint.mdAndUp,
            'display-2': $vuetify.breakpoint.smAndDown,
          }"
          class="font-weight-bold text-center"
        >
          {{ title }}
        </div>
        <div
          :class="{
            headline: $vuetify.breakpoint.mdAndUp,
            'subtitle-2': $vuetify.breakpoint.smAndDown,
          }"
          class="mt-5 text-center"
        >
          <slot>
            {{ subtitle }}
          </slot>
        </div>
        <div class="text-center mt-10" v-if="button">
          <v-btn color="secondary" @click="nextStep">{{ button }}</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Landing",
  props: {
    title: String,
    subtitle: String,
    button: String,
  },
  methods: {
    nextStep() {
      this.$emit("nextStep");
    },
  },
};
</script>
